import { render, staticRenderFns } from "./dialog-set-publishers.vue?vue&type=template&id=845c3cea&"
import script from "./dialog-set-publishers.vue?vue&type=script&lang=js&"
export * from "./dialog-set-publishers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports